import React, { useEffect } from "react";
import {useTranslation} from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../../../redux/actions/auth/manageUser";
import { RootState } from "../../../redux/reducers/root";

import "./LanguageAccessibilty.css";

export default function LanguageAccessibilty(): JSX.Element {
    
    const {t, i18n} = useTranslation(['header', 'login']);
    const accessibiltyText = t('header.accessibility');
    const translationButtonText = t('header.translationButton');
    const isEnglish = i18n.language === 'en';
    const toggleTranslation = () => {
        if(isEnglish){
            i18n.changeLanguage('fr');
            window.localStorage.setItem("prefLang", "fr");
        } else {
            i18n.changeLanguage('en');
            window.localStorage.setItem("prefLang", "en");
        }
    }

    const manageUserInfoState: Record<string, unknown> = useSelector((state: RootState) => state.authReducer.getUser);

    const dispatch = useDispatch();

    useEffect(() => {
        const localUserLanguage = window.localStorage.getItem("prefLang");
        if (!localUserLanguage) {
            let userId = "";
            if (!manageUserInfoState.user_profile_id){
                if (manageUserInfoState.pref_lang) {
                    const userLanguage = manageUserInfoState.pref_lang as string;
                    window.localStorage.setItem("prefLang", userLanguage === "fr_FR" ? "fr" : "en");
                } else {
                    const userProfileId = window.localStorage.getItem("userProfileId");
                    if (userProfileId) {
                        userId = userProfileId;
                    }
                }
            } else {
                userId = manageUserInfoState.user_profile_id as string;
            }
            dispatch(getUserInfo(userId));
        }
    // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let userLanguage = window.localStorage.getItem("prefLang");
        if (!userLanguage) {
            if (manageUserInfoState.pref_lang) {
                userLanguage = manageUserInfoState.pref_lang as string;
                window.localStorage.setItem("prefLang", userLanguage === "fr_FR" ? "fr" : "en");
                if (userLanguage === "fr_FR") {
                    i18n.changeLanguage('fr');
                } else {
                    i18n.changeLanguage('en');
                } 
            }
        }
	}, [manageUserInfoState, i18n]);

    return (
        <div className="lang-access-parent">
            <div className="lang-access-item">
                <a className="amp-anchor" href={t('header.accessibilityLink')}>
                    {accessibiltyText}
                </a>
            </div>
            <div className="lang-access-item">
                <a href={t('header.screenreaderLink')}>
                    <img src="./images/ea_app_icon_new.png" alt={t('header.screenreaderLink')}></img>
                </a>
            </div> 
            <div className="lang-access-item">
                {/* eslint-disable-next-line */}
                <button onClick={() => toggleTranslation()} className="toggle-lang-btn" tabIndex={0}>
                    {translationButtonText}
                </button>
            </div>
        </div>
    )
}